module.exports = __webpack_public_path__ + "img/goldShadowMob.32db2f6a.webp";